import React, { useState } from "react";

import { H4 } from "../../atoms/Texts";
import { NewFormFooter } from "../../organisms/Footers";
import { toastWarning } from "../../../shared/helpers/utils.toasts";
import ModernFormBuilder from "../../molecules/ModernFormBuilder";

export const FormTwo = ({ changeStep, discard, fields, updateFields }) => {
  const [formData, setFormData] = useState(fields.formFields || []);

  const updateData = () => {
    if (formData?.length < 1) {
      toastWarning("Please add at least one field");
    } else {
      updateFields({ formFields: formData });
      changeStep(3);
    }
  };

  return (
    <div className="flex-grow">
      <div className="px-10">
        <H4 className="my-8">{fields?.service?.label}</H4>

        <section className="bg-white my-10  pt-16 pb-24 px-16 border">
          <ModernFormBuilder formData={formData} setFormData={setFormData} />
        </section>
      </div>

      <NewFormFooter
        back={() => changeStep(1)}
        changeStep={updateData}
        discard={discard}
      />
    </div>
  );
};
